import {Experiment, DeploymentConfiguration} from '../entities'

const terms = {
  DEPLOYMENT_CONFIGURATION: 'deploymentConfiguration',
  DEPLOYMENT_CONDITION: 'condition',
  EXPERIMENT_ARCHIVED: 'archived',
  EXPERIMENT_STICKY: 'sticky',
  EXPERIMENT_ID: '_id',
  EXPERIMENT_NAME: 'name',
  EXPERIMENT_FLAGS: 'featureFlags',
  EXPERIMENT_LABELS: 'labels',
  EXPERIMENT_STICKINESS_PROPERTY: 'stickinessProperty',
}

export default class ExperimentsParser {
  _json
  constructor(json) {
    this._json = json
  }

  parse() {
    if (!this._json || !this._json.length) {
      return []
    }

    const experiments = []
    this._json.forEach((experimentJson) => {
      if (
        !experimentJson ||
        !experimentJson[terms.DEPLOYMENT_CONFIGURATION] ||
        !experimentJson[terms.EXPERIMENT_ID] ||
        !experimentJson[terms.EXPERIMENT_NAME] ||
        !experimentJson[terms.EXPERIMENT_FLAGS]
      ) {
        return
      }

      const deploymentConfigurationJson = experimentJson[terms.DEPLOYMENT_CONFIGURATION]
      if (!deploymentConfigurationJson[terms.DEPLOYMENT_CONDITION]) {
        return
      }

      const labels = experimentJson[terms.EXPERIMENT_LABELS] || []

      const deploymentConfiguration = new DeploymentConfiguration(
        deploymentConfigurationJson[terms.DEPLOYMENT_CONDITION]
      )
      experiments.push(
        new Experiment(
          experimentJson[terms.EXPERIMENT_ID],
          experimentJson[terms.EXPERIMENT_NAME],
          !!experimentJson[terms.EXPERIMENT_ARCHIVED],
          !!experimentJson[terms.EXPERIMENT_STICKY],
          deploymentConfiguration,
          experimentJson[terms.EXPERIMENT_FLAGS],
          labels,
          experimentJson[terms.EXPERIMENT_STICKINESS_PROPERTY]
        )
      )
    })

    return experiments
  }
}
